import { COUNTRY_CODES } from "../../../constants/countries";

export const INVOICE_FORM_CONFIG = {
    [COUNTRY_CODES.ECUADOR]: {
        requiredFields: {
            colegio: true,
            cliente: true,
            alumno: false,
        },
        permissions: {
            createClient: true,
            canBuyIndividualBooks: true,
        },
    },
    [COUNTRY_CODES.PARAGUAY]: {
        requiredFields: {
            colegio: false,
            cliente: false,
            alumno: false,
        },
        permissions: {
            createClient: true,
            canBuyIndividualBooks: true,
        }
    },
    [COUNTRY_CODES.HONDURAS]: {
        requiredFields: {
            colegio: false,
            cliente: true,
            alumno: true,
        },
        permissions: {
            createClient: false,
            canBuyIndividualBooks: false,
        }
    },
};

export const getInvoiceFormConfig = (pais) => { return INVOICE_FORM_CONFIG[pais] || INVOICE_FORM_CONFIG[COUNTRY_CODES.ECUADOR]; };